import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getMarketPromotion} from 'api/requests';
import {QueryKeyEnum} from 'types';
import {IMarketPromotionRequest, IMarketPromotionResponse} from 'types';

export const useMarketPromotion = (
  options: UseQueryOptions<IMarketPromotionResponse>,
  query: IMarketPromotionRequest,
) => {
  return useQuery<IMarketPromotionResponse>({
    queryKey: [QueryKeyEnum.MARKETS_PROMOTION],
    queryFn: () => getMarketPromotion(query),
    ...options,
  });
};
